import { Route } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { AppComponent } from './app.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/login/login.component').then(
            (c) => c.LoginPage,
          ),
      },
      {
        path: 'dashboard',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            (r) => r.dashboardRoutes,
          ),
      },
      {
        path: 'download',
        loadComponent: () =>
          import('./pages/download/download.component').then(
            (c) => c.DownloadComponent,
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./pages/health-hub/health-hub.component').then(
            (c) => c.HealthHubComponent,
          ),
      },
    ],
  },
];
